module.exports = "<p>\r\n  cell-actionevent works!\r\n</p>\r\n"